export default __webpack_public_path__ + "static/media/DSA.d31c6e5e.png";